module.exports = __webpack_public_path__ + "e0c089c540e10486ab5ba2825e58ccef.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_1_circ.mp3
 ** module id = 167
 ** module chunks = 0
 **/